export default __webpack_public_path__ + "static/media/left_nav.068925fd.svg";